import { useApolloClient, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { IFrenchAdditionalInfo, IFrenchTaskInfo, IFrenchTransUpdateInput } from "../../types/french";
import { Card, CardBody, CardTitle, FormFeedback, Input, Label } from "reactstrap";
import { SaveIcon } from "../common/icons";
import Textarea from "../common/textarea/textarea";
import { UPDATE_FRENCH_TRANS } from "../../graphql/french-gql";
import SpinnerOverlay from "../common/spinner/spinner";
import ChangeAlert, { ChangeAlertRef } from "../common/change-alert";
import Select from "../common/select/select";
import { ORG_VALUE_LISTS } from "../../graphql/valuelist-gql";
import { IValueListLight } from "../../types/valuelist";
import Button from "../common/button";

interface ItemDetailProp {
  taskInfo: IFrenchTaskInfo ;
   addInfo: IFrenchAdditionalInfo;
   catId: number;
   refresh:  (item: boolean) => void;
   navigateTo: (item: string ) => void;
}

function FrenchItemDetail(props: ItemDetailProp) {
  const { taskInfo,  addInfo, catId, refresh, navigateTo} = props;
  const [updateFrench, setUpdateFrench] = useState<IFrenchTransUpdateInput>({
    id: taskInfo.id,
    catId: catId, 
    metaDataValueId: taskInfo.metaDataValueId,
    entityId: taskInfo.entityId,
    entity: taskInfo.entity,
    fieldValueTranslated: false,
    fieldValueFr: '',
    fieldValue2Fr: '',
    fieldValue2Translated: false
  })
  const [updateTranslation,{loading:updateLoading}] = useMutation<any>(UPDATE_FRENCH_TRANS)
  const [frenchContentError,setFrenchContentError] = useState<string>('')
  const [frenchContent2Error,setFrenchContent2Error] = useState<string>('')
  const [isDirty, setIsDirty] = useState(false)
  const [titlePre, setTitlePre] = useState<string>('')
  const changeAlertRef = useRef<ChangeAlertRef>(null);
  const [frCategory, setCatetory] = useState<IValueListLight>()
  const client = useApolloClient()
  const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})

  useEffect(() => {
    const filteredItems = orgValueLists.frCategory.filter((item: any) => item.id === catId);

    for (const item of filteredItems) {
        setCatetory(item);

        switch (item.code.toUpperCase()) {
          case 'HISTORY':
            setTitlePre("HIST")
            break;

          case 'ADDR':
            setTitlePre("CONTACT_INFO")
            break;
          
          case 'ORG':
            setTitlePre("ORG")
            break;
          
          case 'POS':
            setTitlePre("POS")
            break;
          
          case 'GROUP':
            setTitlePre("HEADER")
            break;
          
          default:
           setTitlePre("Org")
        }
      
    }
  }, [catId])

  useEffect(() => {

    setUpdateFrench({
      id: taskInfo.id,
      catId: catId, 
      metaDataValueId: taskInfo.metaDataValueId,
      entityId: taskInfo.entityId,
      entity: taskInfo.entity,
      fieldValueTranslated: taskInfo.fieldValueTranslated,
      fieldValueFr: (taskInfo?.fieldName == 'Unit Number' && Number(taskInfo?.fieldValueEn) && !taskInfo.fieldValueFr)
        ? taskInfo?.fieldValueEn 
        : taskInfo.fieldValueFr,
      fieldValue2Fr: taskInfo.fieldValue2Fr,
      fieldValue2Translated: taskInfo.fieldValue2Translated
    })
  },[taskInfo,  addInfo]);

  const onUpdateHandle = () => {
    let msg = "This value is required"
    let isValid = true
    if(!updateFrench.fieldValueFr){
       setFrenchContentError(msg)
       isValid = false
    }
    if(taskInfo?.entity=='POS' || taskInfo?.entity=='POSITION'){
      if(!updateFrench.fieldValue2Fr){
        setFrenchContent2Error(msg)
        isValid = false
     }
    }
    if(!isValid) return
    updateTranslation({
      variables: {
        input: {
          ...updateFrench
        }
      },
      onCompleted: (data) => {
        data && refresh(true)
      //  data && notifySuccess()
        changeAlertRef.current?.complete(true)
        sessionStorage.removeItem("taskInfo")
        sessionStorage.removeItem("addInfo")
      }
    })
  }

  const frenchTransUpdate = (event: any) => {
     setFrenchContentError("")

    let  maxLength = taskInfo.fieldValueMaxLen && Number(taskInfo.fieldValueMaxLen) > 2000?  2000 : Number(taskInfo.fieldValueMaxLen)
    if (event.length > maxLength) {
      let msg = 'This value is too long. It should have ' + maxLength + ' characters or fewer.'
      setFrenchContentError(msg)
    }else if (event.length == 0) {
       let msg = " This value is required"
       setFrenchContentError(msg)
    }
    setUpdateFrench({ ...updateFrench, fieldValueFr: event })
    setIsDirty(true)
  }

  const frenchTrans2Update = (event: any) => {
    let  maxLength = taskInfo.fieldValueMaxLen && Number(taskInfo.fieldValueMaxLen) > 2000?  2000 : Number(taskInfo.fieldValueMaxLen)
    setFrenchContent2Error("")
    if (event.length > maxLength) {
      let msg = 'This value is too long. It should have ' + maxLength + ' characters or fewer.'
      setFrenchContent2Error(msg)
    }
    setUpdateFrench({ ...updateFrench, fieldValue2Fr: event })
    setIsDirty(true)
  }

  const handleTransCheckChange = (event: any) => {
    setUpdateFrench({ ...updateFrench, fieldValueTranslated: event?.target?.checked })
    setIsDirty(true)
  }

  const handleTrans2CheckChange = (event: any) => {
    setUpdateFrench({ ...updateFrench, fieldValue2Translated: event?.target?.checked })
    setIsDirty(true)
  }

  const navigateToOrg = () => {
    const orgId = addInfo.orgId? addInfo.orgId.toString(): ""
    //console.log("===================" + orgId)
    navigateTo(orgId)

  }

  const suggestedChange = (event: any) =>{
   // console.log("suggested:" + event?.target?.value);
    let value = event?.target?.value;
    if(value){
      const trans = value.split("|");
      setUpdateFrench({ ...updateFrench, fieldValueFr: trans[0], fieldValue2Fr: trans[1] })
      setIsDirty(true)
    }
  }

  return (
    <>
      {updateLoading && <SpinnerOverlay />}
      <Card >
        <CardBody>
          <CardTitle>{titlePre}: {taskInfo?.fieldValueEn.length > 100 ? taskInfo?.fieldValueEn.substring(0,100)+' ...' : taskInfo?.fieldValueEn}</CardTitle>
          <ChangeAlert isOpen={isDirty}
            itemName={` French Translation`}
            onDiscard={() => setIsDirty(false)}
            ref={changeAlertRef} />

          <div className="oms-row" id="frDetail">
            <Button color="primary" onClick={onUpdateHandle} disabled={!!frenchContentError}>
              <SaveIcon />
              &nbsp;<span role="region" aria-label='save'>Save</span>
            </Button>
          </div>
          <div className="oms-row">
            <div className="col-md-3" >
              <div >Additional Information</div>
            </div>
            <div className="col-md-5" >
              {addInfo?.orgId && <div>Organization: <a href="#" onClick={navigateToOrg}>{addInfo.orgName}</a></div>}
            </div>
            {addInfo.positionName && <div className="col-md-4" >
              {<div>Position: {addInfo.positionName}</div>}
            </div>}
            {/* {addInfo.bizGroupId && <div className="col-md-4" >
              {<div>Header: {addInfo.bizGroupName}</div>}
            </div>} */}
          </div>
          <div className="oms-row">
            <div className="col-md-3" >
              { (taskInfo.entity === 'BIZGRP' ||  taskInfo.entity ==='BIZ_GROUP') && taskInfo?.fieldName === 'Org Group' && <div >English Header</div>}
              { (taskInfo.entity === 'BIZGRP' ||  taskInfo.entity ==='BIZ_GROUP') && taskInfo?.fieldName === 'Group Description' && <div >English Header Description</div>}
              { taskInfo.entity !== 'BIZGRP' && taskInfo.entity !=='BIZ_GROUP' && <div >English {taskInfo?.fieldName}</div>}

            </div>
            <div className="col-md-9" >
              <div>{taskInfo?.fieldValueEn}</div>
            </div>
          </div>
          {addInfo.suggested && <div className="oms-row">
            <div className="col-md-3" >
              <div >Suggested Translations</div>

            </div>
            <div className="col-md-9" >
              <div><Select id="suggested"
                        name="categoryId"
                        lang="fr"
                        onChange={suggestedChange}
                        aria-label="Suggested Translations">
                          <option key="0" value="" ></option>
                  {addInfo.suggested.map((item: string)=> <option key={item} value={item} lang="fr">{item}</option>)}
                </Select></div>
            </div>
          </div>}
          <div className="oms-row" >
            <div className="col-md-3" >
              <Label for="frenchContent">
              { (taskInfo.entity === 'BIZGRP' ||  taskInfo.entity ==='BIZ_GROUP') && taskInfo?.fieldName === 'Org Group' && <div >French Header</div>}
              { (taskInfo.entity === 'BIZGRP' ||  taskInfo.entity ==='BIZ_GROUP') && taskInfo?.fieldName === 'Group Description' && <div >French Header Description</div>}
              { taskInfo.entity !== 'BIZGRP'  && taskInfo.entity !=='BIZ_GROUP' && <div>French {taskInfo?.fieldName}</div>}
              { (taskInfo?.entity=='POS' || taskInfo?.entity=='POSITION') && <div>(Masculine)</div>}</Label>
            </div>
            <div className="col-md-9" >
              <Textarea id="frenchContent" name="frenchContent"
                placeholder="Enter french translation"
                rows={3}
                value={  updateFrench.fieldValueFr ?? ""}
                onValueChange={frenchTransUpdate}
                invalid={!!frenchContentError}
                lang="fr"
                maxLength={taskInfo.fieldValueMaxLen ? parseInt(taskInfo.fieldValueMaxLen) : 0}
                invalidMessage={frenchContentError}
                />
            </div>
          </div>

          <div className="oms-row" >
            <div className="col-md-3" >
              <Input type="checkbox" id="translated" name="translated"
                checked={updateFrench.fieldValueTranslated} onChange={handleTransCheckChange} />
              {' '}
              <Label for="translated" check>Translated</Label>
            </div>
          </div>
          {
            (taskInfo?.entity=='POS' || taskInfo?.entity=='POSITION') &&<>
          <div className="oms-row">
            <div className="col-md-3" >
              <Label for="frenchContent2"><div>French {taskInfo?.fieldName2} (Feminine) </div></Label>
            </div>
            <div className="col-md-9" >
              <Textarea id="frenchContent2" name="frenchContent"
                placeholder="Enter french translation"
                rows={3}
                value={updateFrench.fieldValue2Fr ?? ""}
                onValueChange={frenchTrans2Update}
                invalid={!!frenchContent2Error}
                lang="fr"
                maxLength={taskInfo.fieldValueMaxLen ? parseInt(taskInfo.fieldValueMaxLen) : 0}
                invalidMessage={frenchContent2Error}
                />
            </div>
          </div>
          <div className="oms-row">
            <div className="col-md-3" >
              <Input type="checkbox" id="translated-fem" name="translated-fem"
                checked={updateFrench.fieldValue2Translated} onChange={handleTrans2CheckChange} />
              {' '}
              <Label for="translated-fem" check>Translated</Label>
            </div>
          </div>
          </>}
        </CardBody>
      </Card>
    </>
  )
}

export default FrenchItemDetail;
